<template>
  <div class="container-fluid mt-3 bg-white">
    <div class="row">
      <div class="col-md-6 p-5">
        <h1 class="text-uppercase font-basetheme font-kanit text-center">EMERALD TECH ADVANCE</h1>
        <div class="w-50 colunm-border-bottom m-auto"></div>
        <ul class="list-unstyled font-grey font-Krub font-1x2 mt-5">
          <li>
            <span class="mdi mdi-chevron-right-circle font-secondtheme"></span> บริษัท เอ็มเมอรัลด์ เทค แอดวานซ์ จำกัด ก่อตั้งเมื่อวันที่ 22 พฤษภาคม 2560
          </li>
          <li>
            <span class="mdi mdi-chevron-right-circle font-secondtheme"></span> บริษัทฯ ดำเนินธุรกิจประเภทการให้บริการจัดหาเทคโนโลยี พัฒนาระบบฯ สรรสร้างนวัตกรรม และให้คำปรึกษาทางด้านเทคโนโลยีและธุรกิจ
          </li>
          <li>
            <span class="mdi mdi-chevron-right-circle font-secondtheme"></span> บริษัทฯ พร้อมให้บริการด้วยทีมงานที่ความสามารถและประสบการณ์ทางด้านเทคโนโลยี การตลาด และธุรกิจระหว่างประเทศ เพื่อพัฒนาสินค้าและบริการแบบครบวงจรทั้งภาครัฐและภาคเอกชน
          </li>
        </ul>
      </div>
      <div class="col-md-6 p-0">
        <img src="@/assets/img/home/young-791849_640.jpg" class="d-block w-100" alt="..." />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>